const RESTRICTED_NATIVE_PREFIXES = ['/admin', '/enterprise', '/debug', '/error-logs', '/marketing'];
const RESTRICTED_NATIVE_EXACT_PATHS = new Set(['/admin-demo']);

export function isNativeConsumerShell(): boolean {
  if (typeof window === 'undefined') return false;

  const cap = (window as unknown as { Capacitor?: any }).Capacitor;
  if (!cap) return false;

  try {
    if (typeof cap.isNativePlatform === 'function') {
      return Boolean(cap.isNativePlatform());
    }
    if (typeof cap.getPlatform === 'function') {
      return cap.getPlatform() !== 'web';
    }
    return Boolean(cap.platform && cap.platform !== 'web');
  } catch {
    return false;
  }
}

export function isRestrictedInNativeConsumerShell(pathname: string): boolean {
  if (RESTRICTED_NATIVE_EXACT_PATHS.has(pathname)) return true;
  return RESTRICTED_NATIVE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
